import { Component, OnInit } from '@angular/core';
import { Agenda } from 'src/app/models/models';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit {

  
  private _agendas : Agenda[];
  public get agendas() : Agenda[] {
    return this._agendas;
  }
  public set agendas(v : Agenda[]) {
    this._agendas = v;
  }
  
  constructor() {
    this.agendas = [
      {day: "Lundi",lieu: "Cabinet medical Huy",heure: "8:30-18:00"},
      {day: "Mardi",lieu: "CHR Huy",heure: "8:00-18:00"},
      {day: "Mercredi",lieu: "Cabinet privé Andenne",heure: "8:00-12:30"},
      {day: "Jeudi",lieu: "Cabinet privé Andenne",heure: "8:00-12:30"},
      {day: "Vendredi",lieu: "CHR Huy",heure: "8:00-18:00"},

    ]
   }

  ngOnInit(): void {
  }

}
